import { apiClient } from '../client';
  import { ApiResponse } from '../../../contract/types';
  import { TenantProductDTO } from '../../../contract/dtos';
export interface TenantProductQueryParams {
    tenant_id?: number;
    component_id?: number;
    sort?: string;
    size?: number;
    page?: number;
    name?: string;
    id?:string;
    price_from?:string;
    price_to?:string;
    categories?:string;
    brands?:string;
    currently_assigned?:boolean;
    product_id?:string;
    customer_view?:boolean;
    tenant_product_name?:string;
    brand_name?:string;
    branch_id?:string;
    category_name?:string;
  }
  
  
  // Get tenant products with query parameters
  export const getTenantProducts = async (params?: TenantProductQueryParams): Promise<ApiResponse<TenantProductDTO[]>> => {
    const response = await apiClient.get('/corporate/v1/tenant-products', {
      params: {
        ...params,
        currency_code:'SAR'
      },
    });
  
    // Extract total count from headers
    const total = parseInt(response.headers['x-total-count'] || '0', 10);
  
    return {
      data: response.data,
      total,
    };
  };
  export interface CommonProductQueryParams {
    component_id?: number;
    tenant_id?: number;
    sort?: string;
    size?: number;
    page?: number;
    name?: string;
    id?:string;
    price_from?:string;
    price_to?:string;
    categories?:string;
    brand_name?:string;
  }
  export const getCommonProducts = async (params?: CommonProductQueryParams): Promise<ApiResponse<any[]>> => {
    const response = await apiClient.get('/corporate/v1/product', {
      params
    });
  
    // Extract total count from headers
    const total = parseInt(response.headers['x-total-count'] || '0', 10);
  
    return {
      data: response.data,
      total,
    };
  };